import { EnvironmentProviders, Provider } from '@angular/core';
import { PrintService } from '@softapps/werkstatt/garage-core';

// Cross-cutting/module-level providers WITHOUT the routes graph — composed at
// boot both by provideGarageReport (monolith path) and the remote's
// ./ModuleGlobals entry (federation path). Must not import the routes file.
export function provideGarageReportGlobals(): Array<
  Provider | EnvironmentProviders
> {
  return [{ provide: PrintService, useFactory: () => new PrintService() }];
}
